import {
    GET_MERCHANT_PERMISSION,
    GET_MERCHANT_PERMISSION_SUCCESS,
    GET_MERCHANT_SUBMERCHANTID,
    GET_MERCHANT_SUBMERCHANTID_SUCCESS,
    GET_MERCHANT_PERMISSION_BYMERCHANTID,
    GET_MERCHANT_PERMISSION_BYMERCHANTID_SUCCESS,
    MERCHANT_PERMISSION_API_ERROR
} from "./actionTypes"

export const getMerchantPermission = userName => ({
    type: GET_MERCHANT_PERMISSION,
    payload: userName,
  })

export const getMerchantPermissionSuccess = guid => ({
    type: GET_MERCHANT_PERMISSION_SUCCESS,
    payload: guid,
  })

  export const getMerchantSubMerchantId = userName => ({
    type: GET_MERCHANT_SUBMERCHANTID,
    payload: userName,
  })

export const getMerchantSubMerchantIdSuccess = guid => ({
    type: GET_MERCHANT_SUBMERCHANTID_SUCCESS,
    payload: guid,
  })

export const getMerchantPermissionByMerchantId = merchantId => ({
  type: GET_MERCHANT_PERMISSION_BYMERCHANTID,
  payload: merchantId,
})

export const getMerchantPermissionByMerchantIdSuccess = guid => ({
    type: GET_MERCHANT_PERMISSION_BYMERCHANTID_SUCCESS,
    payload: guid,
  })

export const merchantPermissionApiError = error => {
    return {
        type: MERCHANT_PERMISSION_API_ERROR,
        payload: error,
    }
}
